var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10236",
    "data-name": "Group 10236",
    transform: "translate(-1224 -126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2262",
    "data-name": "Rectangle 2262",
    transform: "translate(1224 126)",
    fill: "#fff",
    stroke: "#152c40",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2265",
    "data-name": "Rectangle 2265",
    transform: "translate(1224 140)",
    fill: "#fff",
    stroke: "#152c40",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2263",
    "data-name": "Rectangle 2263",
    transform: "translate(1238 126)",
    fill: "#fff",
    stroke: "#152c40",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2264",
    "data-name": "Rectangle 2264",
    transform: "translate(1238 140)",
    fill: "#fff",
    stroke: "#152c40",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon10);
export default __webpack_public_path__ + "static/media/social-icon10.3af1c86ee3bdbcd49d58b815a70b9350.svg";
export { ForwardRef as ReactComponent };